<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择维保"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  maintenanceChooseList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'orderCode',
      tableSelectTar: 'orderCode',
      searchBoxDataTmpl: {
        form: [
          { // 司机姓名
            label: '司机姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 司机手机
            label: '司机手机',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入司机手机',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerCode',
          label: '司机姓名',
        },
        {
          prop: 'companyName',
          label: '司机手机',
        },
      ],
      tableTitle: [
        {
          prop: 'orderCode',
          label: '维保单号',
        },
        {
          prop: 'workTypeName',
          label: '维修项目',
        },
        {
          prop: 'outFactoryTime',
          label: '维修日期',
        },
        {
          prop: 'repairOrgName',
          label: '维修部门',
        },
        {
          prop: 'carNo',
          label: '车牌号码',
        },
        {
          prop: 'vehicleOrgName',
          label: '车辆归属部门',
        },
        {
          prop: 'serviceUserName',
          label: '服务商',
        },
        {
          prop: 'shopName',
          label: '维修站点',
        },
        {
          prop: 'contractMobile',
          label: '维修师傅电话',
        },
        {
          prop: 'checkAmount',
          label: '维修费用（元）',
        },
        {
          prop: 'serviceContent',
          label: '维修内容',
        },
      ],
    };
  },
  methods: {
    getListApi: maintenanceChooseList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
